import { render } from "./BaseDataTableBtn.vue?vue&type=template&id=0738a451"
import script from "./BaseDataTableBtn.vue?vue&type=script&lang=js"
export * from "./BaseDataTableBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__